import React from 'react';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { RadioGroup, FormControlLabel, Radio, Grid, Switch } from '@material-ui/core';
import { PERCENT, RUPEES_VALUE } from '../../constants';
import styled from 'styled-components';

const toggleStyles = {
  container: {
    display: 'flex',
    width: '160px',
    justifyContent: 'space-between'
  },
  drContiner: {
    paddingLeft: '10px'
  }
};

const StyledLabel = styled.span`
  font-size: 11px;
  color: #4f4f4f;
`;

const toggleDiscountUnitStyles = {
  container: {
    display: 'flex',
    // width: '10rem',
    paddingLeft: '1.625rem',
    marginTop: '0.8rem'
  },
  discountContiner: {
    paddingLeft: '1.625rem'
  }
};
const Toggle = ({ onClick, checked }) => (
  <RadioButtonGroup
    name="shipSpeed"
    valueSelected={checked ? 'Dr' : 'Cr'}
    style={toggleStyles.container}
    onChange={() => onClick()}
  >
    <RadioButton value="Cr" label="Credit" />
    <RadioButton value="Dr" label="Debit" style={toggleStyles.drContiner} />
  </RadioButtonGroup>
);

const ToggleForDiscountUnit = ({ onClick, value, classes }) => (
  <div>
    <Grid component="label" container alignItems="center" spacing={1}>
      <Grid item style={{ fontWeight: value === PERCENT ? 'bold' : 'initial' }}>
        %
      </Grid>
      <Grid item>
        <Switch
          id="additional-discount-radio-percent"
          classes={{ switchBase: classes.switchBase }}
          checked={value === RUPEES_VALUE}
          onChange={e => onClick(e.target.checked ? RUPEES_VALUE : PERCENT)}
          name="additional-discount"
          color="primary"
        />
      </Grid>
      <Grid item style={{ fontWeight: value === RUPEES_VALUE ? 'bold' : 'initial' }}>
        Rs
      </Grid>
    </Grid>
  </div>
  // <RadioGroup
  //   row
  //   aria-label="additional-discount"
  //   name="additional-discount"
  //   value={value}
  //   onChange={e => onClick(e.target.value)}
  //   style={{ marginLeft: '1rem' }}
  // >
  //   <FormControlLabel
  //     value="%"
  //     control={<Radio id="additional-discount-radio-percent" classes={{ root: classes.radio }} />}
  //     label="%"
  //   />
  //   <FormControlLabel
  //     value="Rupees"
  //     control={<Radio classes={{ root: classes.radio }} />}
  //     label="Rs"
  //   />
  // </RadioGroup>
);

const ToggleSwitch = ({ checked, onChange, label, value }) => (
  <FormControlLabel
    control={
      <Switch
        checked={checked}
        onChange={event => {
          onChange(event.target.checked);
        }}
        value={value}
        color="primary"
        size="small"
      />
    }
    label={<StyledLabel>{label}</StyledLabel>}
  />
);
export { Toggle, ToggleForDiscountUnit, ToggleSwitch };
